export default __webpack_public_path__ + "static/media/mediagal_pos1.89693695.jpg";